module.exports = __webpack_public_path__ + "img/zw_2.957e6e35.jpg";